export default __webpack_public_path__ + "static/media/cheese.b328e84a.jpg";